/*Edit thong tin ve nguon tin va tai nan, phuong tien bi nan */
import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Input from "@material-ui/core/Input";
import MaskedInput from "react-text-mask";
import PropTypes from "prop-types";
import SelectFilter from "react-select";
import Select from "@material-ui/core/Select";
import CircularProgress from "@material-ui/core/CircularProgress";
import DateTimePicker from "react-datetime";
import MyLatLonEditor from "./LatLonEditor";
import ConfirmDialog from "../ConfirmDialog";
import TauSarEditDialog from '../danhmuc/TauSarEditDialog';

import {
  DatePicker,
  TimePicker,
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
} from "@material-ui/pickers";

import moment from "moment";

import MyButton from "../MyButton";
import { FormHelperText } from "@material-ui/core";

const myLib = require("../../lib/MyLib");
const server = require("../../lib/server");
const sukienLayer = require("../../lib/SuKienDataLayer");
const uuidV4 = require("uuid/v4");

const defaultRecord = {
  MaSK: null,
  MaTau: null,
  STT: 1,
  TenTau: null,
  LoaiHinh: "1",
  NgayRoi: null,
  NgayKetThuc: null,
  BiThuong: 0,
  BiBenh: 0,
  Lat: null,
  Lon: null,
  ThoiGianVT: null,
  ViTri: null,
  TrongTai: null,
  CongSuat: null,
  GhiChu: '',
};

///////////////////////////////////////////////////////////////////
class SuKienDieuDongControl extends React.Component {
  constructor(props) {
    super(props);
    this.saveField = this.saveField.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.insertHanhTrinh = this.insertHanhTrinh.bind(this);
    this.state = {
      dataSaved: props.value !== undefined, //ban ghi da duoc cap nhat hay chua
      canSaved: false, //cho phep save hay khong
      dataChanged: false, //du lieu co su thay doi hay khong
      saving: false, //co dang save du lieu hay khong
      errorLog: "", //mo ta loi neu co
      //confirm xoa phuong tien
      showConfirmXoa: false,
      //danh muc quoc gia
      loading_tausar: true, // co dang loading danh muc quoc gia khong
      source_tausar: [], //danh muc options cho quoc tich
      open_them_tausar: false,
      //danh muc loai tau
      loading_loaitau: true, // co dang loading danh muc loai tau
      source_loaitau: [], //danh muc options cho loai tau
      
      before:
        props.value === undefined
          ? {
              ThoiGian: new Date(),
            }
          : myLib.cloneObject(props.value), //thong tin truoc khi edit
      after:
        props.value === undefined
          ? { ...defaultRecord, STT: props.stt, MaTau: uuidV4() + "" }
          : {
              ...defaultRecord,
              STT: props.stt,
              MaTau: uuidV4() + "",
              ...props.value,
            }, //thong tin dang edit
      validateStatus: { error: false }, //trang thai validate
    };
  }
  //ghi nhan gia tri nhap
  saveField = (fieldName, value) => {
    var old_changed = this.state.dataChanged;
    var s = this.state;
    s.after[fieldName] = value;
    s.dataChanged = !myLib.isSame(s.before, s.after, [
      "TenTau",
      "LoaiHinh",
      "NgayRoi",
      "NgayKetThuc",
      "BiThuong",
      "BiBenh",
      "Lat",
      "Lon",
      "ThoiGianVT",
      "ViTri",
      "TrongTai",
      "CongSuat",
      'GhiChu',
    ]);
    s.canSaved = s.dataChanged;
    console.log(s);
    if(this.props.onChanged && old_changed != s.dataChanged) {
      this.props.onChanged(s.dataChanged);
    }
    this.setState(s);
  };
  //submit thong tin ve DB
  handleSave = () => {
    console.log("phuong tien ", JSON.stringify(this.state.after));
    var check = sukienLayer.validate("dieudong", this.state.after);
    console.log("check ", check);
    if (!check.error) {
      this.setState({ validateStatus: {}, saving: true, errorLog: "" });
      server
        .post(
          "sukien/saveDieudong",
          sukienLayer.chuanHoaSukien("dieudong", this.state.after)
        )
        .then((response) => {
          var before = {};
          var after = { ...this.state.after };
          Object.assign(before, after);
          this.setState({
            before: before,
            after: after,
            dataChanged: false,
            canSaved: false,
            saving: false,
            errorLog: "",
            dataSaved: true,
          });
          //thong bao cho parent biet co data duoc saved
          if (this.props.onSaved) {
            this.props.onSaved(after);
          }
          if(this.props.onChanged) {
            this.props.onChanged(false);
          }
        })
        .catch((error) =>
          this.setState({ saving: false, errorLog: error + "" })
        );
    } else {
      this.setState({ validateStatus: check });
    }
  };
  loadDanhMuc() {
    //load danh muc ten tau sar
    server
      .query("tausar/getall")
      .then((response) => {
        var list = [];
        response.map((item, index) =>
          list.push({ value: item.TenTau, label: item.TenTau })
        );
        this.setState({ source_tausar: list, loading_tausar: false });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading_tausar: false });
      });
  }
  //them vao hanh trinh tau
  insertHanhTrinh() {
    var lat = this.state.after.Lat;
    var lon = this.state.after.Lon;
    var time = this.state.after.ThoiGianVT;
    if(myLib.toString(lat) !== '' && myLib.toString(lon) !== '' && myLib.toString(time)) {
      //kiem tra xem trong hanh trinh da co hay chua
      var list = this.state.after.ViTri ? this.state.after.ViTri.split(/\n/) : [];
      var item = myLib.latToDMS(lat) + ';' + myLib.lonToDMS(lon) + ';' + myLib.formatDate(time, 'DD/MM/yyyy HH:mm');
      var found = false;
      console.log(list);
      list.map((i,index) => {
        if(!found && i === item) {
          found = true;
        }
      });
      if(!found) {
        this.setState({after: {...this.state.after, ViTri: this.state.after.ViTri + item + '\n'}});
      }
    }
  }
  //khi load component: load cac danh muc can thiet
  componentDidMount() {
    this.loadDanhMuc();
  }
  static getDerivedStateFromProps(props, state) {
    var newState = { ...state };
    if (props.value !== undefined) {
      newState.after.MaSK = props.value.MaSK; //lay ma su kien thong qua props
    }
    return newState;
  }
  render() {
    const { classes, theme } = this.props;
    return (
      <Accordion disabled={this.props.disabled} 
        defaultExpanded={this.props.value !== undefined}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          classes={{
            root: classes.normalPanel,
            expanded: classes.expandedPanel,
            content: classes.summaryContent
          }}
        >
          <Typography className={classes.heading}>
            Điều động TKCN
            {this.props.stt === 1 ? undefined : "/Tàu thứ " + this.props.stt}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={2}>
              <FormControl className={classes.formControl}>
                <InputLabel id="demo-simple-select-label"
                                onClick={
                  global.User.Quyen.R181
                    ? (event) => this.setState({ open_them_tausar: true })
                    : undefined
                }
                >
                  Tàu SAR(*):
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  className={classes.textbox}
                  autoWidth={true}
                  labelWidth={100}
                  value={this.state.after.TenTau}
                  onChange={(event) =>
                    this.saveField("TenTau", event.target.value)
                  }
                  error={this.state.validateStatus.TenTau !== undefined}
                >
                  {this.state.source_tausar.map((item, index) => (
                    <MenuItem value={item.value}>{item.label}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={2}>
              <InputLabel
                id="labelTungay"
                className={
                  this.state.validateStatus.NgayRoi !== undefined
                    ? classes.labelError
                    : classes.label
                }
              >
                Ngày rời(*):
              </InputLabel>
              <DateTimePicker
                id="txtNgayRoi"
                dateFormat="DD/MM/YYYY"
                timeFormat="HH:mm"
                closeOnSelect={true}
                value={this.state.after.NgayRoi}
                inputProps={{
                  maxLength: 100,
                  onBlur: (event) => {
                    var text = event.target.value;
                    if(this.state.after.NgayRoi === null && text != '') {
                      var date = myLib.tryToDate(text);
                      if(date) {
                        this.saveField('NgayRoi', date);
                      }
                    }
                  }
                }}
                onChange={(date) =>
                  this.saveField("NgayRoi", date && date.toDate ? date.toDate() : null)
                }
              />
            </Grid>
            <Grid item xs={2}>
              <InputLabel
                id="labelTungay"
                className={
                  this.state.validateStatus.NgayRoi !== undefined
                    ? classes.labelError
                    : classes.label
                }
              >
                Ngày kết thúc(*):
              </InputLabel>
              <DateTimePicker
                id="txtNgayKetThuc"
                dateFormat="DD/MM/YYYY"
                timeFormat="HH:mm"
                closeOnSelect={true}
                value={this.state.after.NgayKetThuc}
                inputProps={{
                  maxLength: 100,
                  onBlur: (event) => {
                    var text = event.target.value;
                    if(this.state.after.NgayKetThuc === null && text != '') {
                      var date = myLib.tryToDate(text);
                      if(date) {
                        this.saveField('NgayKetThuc', date);
                      }
                    }
                  }
                }}
                onChange={(date) =>
                  this.saveField("NgayKetThuc", date && date.toDate ? date.toDate() : null)
                }
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                id="txtBiThuong"
                className={classes.textbox}
                label="Cán bộ bị thương,bệnh:"
                type="number"
                value={this.state.after.BiThuong}
                inputProps={{
                  maxLength: 9,
                }}
                onChange={(event) =>
                  this.saveField("BiThuong", event.target.value)
                }
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="txtGhichu"
                className={classes.textbox}
                label="Ghi chú:"
                multiline
                value={this.state.after.GhiChu}
                inputProps={{}}
                onChange={(event) =>
                  this.saveField("GhiChu", event.target.value)
                }
              />
            </Grid>
            <Grid item xs={2}>
              <MyLatLonEditor
                id="txtLat"
                latlon="lat"
                label="Vĩ độ:"
                value={this.state.after.Lat}
                onChange={(lat) => this.saveField("Lat", lat)}
              />
            </Grid>
            <Grid item xs={2}>
              <MyLatLonEditor
                id="txtLon"
                latlon="lon"
                label="Kinh độ:"
                value={this.state.after.Lon}
                onChange={(lon) => this.saveField("Lon", lon)}
              />
            </Grid>
            <Grid item xs={2}>
              <InputLabel
                id="labelTungay"
                className={
                  this.state.validateStatus.ThoiGianVT !== undefined
                    ? classes.labelError
                    : classes.label
                }
              >
                Thời gian vị trí(*):
              </InputLabel>
              <DateTimePicker
                id="txtNgayKetThuc"
                dateFormat="DD/MM/YYYY"
                timeFormat="HH:mm"
                closeOnSelect={true}
                value={this.state.after.ThoiGianVT}
                inputProps={{
                  maxLength: 100,
                  onBlur: (event) => {
                    var text = event.target.value;
                    if(this.state.after.ThoiGianVT === null && text != '') {
                      var date = myLib.tryToDate(text);
                      if(date) {
                        this.saveField('ThoiGianVT', date);
                      }
                    }
                  }
                }}
                onChange={(date) =>
                  this.saveField("ThoiGianVT", date && date.toDate ? date.toDate() : null)
                }
              />
            </Grid>
            <Grid item xs={2}>
              <MyButton
                  onClick={this.insertHanhTrinh}
                  color="primary"
                  text="Thêm hành trình"
                />
            </Grid>
            <Grid item xs={2}></Grid>
            <Grid item xs={4}>
              <TextField
                id="txtVitri"
                className={classes.textbox}
                label="Hành trình:"
                multiline
                value={this.state.after.ViTri}
                inputProps={{}}
                onChange={(event) =>
                  this.saveField("ViTri", event.target.value)
                }
              />
            </Grid>

            {/*
            <Grid item xs={4}>
              <TextField
                id="txtTrongTai"
                className={classes.textbox}
                label="Trọng tải:"
                type="number"
                value={this.state.after.TrongTai}
                inputProps={{
                  maxLength: 9,
                }}
                onChange={(event) =>
                  this.saveField("TrongTai", event.target.value)
                }
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="txtCongSuat"
                className={classes.textbox}
                label="Công suất:"
                type="number"
                value={this.state.after.CongSuat}
                inputProps={{
                  maxLength: 6,
                }}
                onChange={(event) =>
                  this.saveField("CongSuat", event.target.value)
                }
              />
            </Grid>*/}
            
            <Grid item xs={2}>
              {this.state.canSaved ? (
                <MyButton
                  onClick={this.handleSave}
                  color="primary"
                  text="Lưu"
                />
              ) : null}
            </Grid>
            <Grid item xs={4}>
              {this.state.dataSaved &&
              this.props.stt === 1 &&
              this.props.allowAddMore ? (
                <MyButton
                  onClick={() => {
                    if (this.props.onAddMore) {
                      this.props.onAddMore(this.props.stt);
                    }
                  }}
                  color="primary"
                  text="Thêm phương tiện khác"
                />
              ) : null}
            </Grid>
            <Grid item xs={4}>
              {this.props.stt > 1 ? (
                <MyButton
                  onClick={() => {
                    this.setState({ showConfirmXoa: true });
                  }}
                  color="primary"
                  text="Xóa phương tiện"
                />
              ) : null}
            </Grid>

            <Grid item xs={10}>
              {this.state.saving ? (
                <CircularProgress />
              ) : this.state.errorLog === "" ? null : (
                this.state.errorLog
              )}
            </Grid>
            {this.state.showConfirmXoa ? (
              <ConfirmDialog
                message="Xóa phương tiện ?"
                callback={(ok) => {
                  if (ok) {
                    this.setState({
                      showConfirmXoa: false,
                      validateStatus: {},
                      saving: true,
                      errorLog: "",
                    });
                    server
                      .post("sukien/removeDieudong", this.state.after)
                      .then((response) => {
                        var before = {};
                        var after = { ...this.state.after };
                        Object.assign(before, after);
                        this.setState({
                          before: before,
                          after: after,
                          dataChanged: false,
                          canSaved: false,
                          saving: false,
                          errorLog: "",
                          dataSaved: true,
                        });
                        //thong bao cho parent biet co data duoc saved
                        if (this.props.onRemoved) {
                          this.props.onRemoved(this.props.stt);
                        }
                      })
                      .catch((error) =>
                        this.setState({ saving: false, errorLog: error + "" })
                      );
                  } else {
                    this.setState({ showConfirmXoa: false });
                  }
                }}
              />
            ) : null}
            {this.state.open_them_tausar ? (
            <TauSarEditDialog
              visible={this.state.open_them_tausar}
              fullWidth={true}
              maxWidth={"sm"}
              EditMode="them"
              onClose={(result) => {
                this.setState({ open_them_tausar: false });
              }}
              onSaved={(record) => {
                var list = [].concat(this.state.source_tausar);
                var new_item = {
                  value: record.TenTau,
                  label: record.TenTau,
                };
                list.unshift(new_item);
                this.setState({
                  source_tausar: list,
                  dataChanged: true,
                  canSaved: true,
                  after: { ...this.state.after, TenTau: record.TenTau },
                });
              }}
            />
          ) : null}
          </Grid>
        </AccordionDetails>
      </Accordion>
    );
  }
}
const styles = (theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
    heigh: "fit-content",
  },
  formControl: {
    marginTop: 2,
    minWidth: 120,
  },
  label: {
    margin: 6,
  },
  labelError: {
    margin: 6,
    color: "red",
  },

  thoigian: {
    marginLeft: 1,
    marginRight: 1,
    width: 200,
  },
  textbox: {
    marginLeft: 1,
    marginRight: 1,
    width: "100%",
  },
  uppercaseText: {
    textTransform: "uppercase",
  },
  normalPanel: {
    backgroundColor: "lightskyblue",
    margin: 0,
    minHeight: 11,
  },
  expandedPanel: {
    backgroundColor: "skyblue",
    margin: 0,
    minHeight: '10px !important',
  },
  summaryContent: {
    margin: '1px !important',
  },
  normalLabel: {
    color: "black",
  },
  redLabel: {
    color: "red",
  },
});
export default withStyles(styles, { withTheme: true })(SuKienDieuDongControl);
